export default __webpack_public_path__ + "static/media/alejandro-loguercio-violin.8447c632.jpg";